export { default } from "./WalletDetail";

